import React, { useEffect } from 'react'
import { FiltersState } from '../../subscriptions/store/store'
import QuickLinks from './QuickLinks'
import PartnerSummary from './PartnerSummary'
import SubscriptionsChartWidget from './SubscriptionsChartWidget'
import Content from '../../../components/layout/Content'
import './Dashboard.css'

type Props = {
  state: FiltersState
  partnerId?: string
  loadFilters: (partnerId: string) => Promise<void>
}

function Dashboard(props: Props) {
  const { loadFilters, partnerId } = props

  useEffect(() => {
    if (partnerId) {
      loadFilters(partnerId)
    }
  },
    // eslint-disable-next-line
    [partnerId])

  return (
    <Content>
      <div id="dashboard">
        {partnerId && (
          <>
            <PartnerSummary partnerId={partnerId} />
            <QuickLinks/>
            <SubscriptionsChartWidget partnerId={partnerId} />
          </>
        )}
      </div>
    </Content>
  )
}

export default Dashboard
